import axiosClient from "./axiosClient";

const consultantAndFragmentService = {
  // Nation
  getLitConsultantAndFragment: async params => {
    const url = "/qlkhambenh/phieu-tu-van/list-phieu-tu-van";
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getDetailConsultantAndFragmentById: async id => {
    const url = `/qlkhambenh/phieu-tu-van?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListStatus: async () => {
    const url = `/qlkhambenh/dm-trang-thai-phieu-tu-van/list-dm-trang-thai-phieu-tu-van`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getDataPayPrintAddService: async id => {
    const url = `qlttbhyt-service/thanh-toan/phieu-thu-tien-tu-van?idPhieuKham=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListReason: async () => {
    const url = `/qlkhambenh/dm-ly-do-tu-choi/list-dm-ly-do-tu-choi`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getExamineHistoryList: async id => {
    const url = `/qlkhambenh/lich-su-kham-benh?idPhieuKham=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  updateDetail: async data => {
    const url = `/qlkhambenh/phieu-tu-van`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  //modal
  getSurgeryAgree: async id => {
    const url = `/qlkhambenh/phieu-tu-van/xem-lich-phau-thuat?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  getSurgeryDisagree: async id => {
    const url = `/qlkhambenh/phieu-tu-van/xem-ly-do-phau-thuat?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  getStatusCatalog: async () => {
    const url = `/qlkhambenh/dm-tt-dich-vu-ky-thuat/list-dm-tt-dich-vu-ky-thuat`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  //lấy danh mục

  getListCatalog: async params => {
    const url = `/qlkhambenh/phau-thuat/danh-muc-phau-thuat`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  postSurgeryAgree: async data => {
    const url = `/qlkhambenh/phieu-tu-van/dat-lich-phau-thuat`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  postSurgeryDisagree: async data => {
    const url = `/qlkhambenh/phieu-tu-van/tu-choi-phau-thuat`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  putSurgeryAgree: async data => {
    const url = `/qlkhambenh/phieu-tu-van/dat-lich-phau-thuat`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  putSurgeryDisagree: async data => {
    const url = `/qlkhambenh/phieu-tu-van/tu-choi-phau-thuat`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  updateStatusConsultantAndFragment: async params => {
    const url = `/qlkhambenh/phieu-tu-van/cap-nhat-trang-thai`;
    const response = await axiosClient.put(url, {}, {params: params});
    return response.data;
  },

  //gói dịch vụ
  getServicePacket: async params => {
    const url = `/qlkhambenh/list-dm-goi-dich-vu`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  postServicePacket: async data => {
    const url = `/qlkhambenh/phieu-tu-van/goi-phau-thuat`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  //bao cao phau thuat
  getDataReportPT: async params => {
    const url = `/qlkhambenh/phieu-tu-van/bao-cao-tv-pt`;
    const response = await axiosClient.get(url, {params: params});
    return response;
  },

  getDataExportReportPT: async params => {
    const url = `/qlkhambenh/phieu-tu-van/export-bao-cao-tv-pt`;
    const response = await axiosClient.get(url, {
      params: params,
      responseType: "blob",
    });
    return response;
  },
  deleteBNCoLichPT: async id => {
    const url = `/qlkhambenh/phieu-cskh`;
    const params = {id: id};
    const response = await axiosClient.delete(url, {params: params});
    return response;
  },
};

export default consultantAndFragmentService;
